import {
  Injectable, Provider, Type,
} from '@angular/core'
import { Subject } from 'rxjs'

export function provideHeroCarouselIntl(intl: Type<HeroCarouselIntl>): Provider {
  return {
    provide: HeroCarouselIntl,
    useClass: intl,
  }
}

@Injectable({ providedIn: 'root' })
export class HeroCarouselIntl {
  public readonly changes$ = new Subject<void>()

  public previousPageButtonLabel = 'Previous page'

  public nextPageButtonLabel = 'Next page'
}
